// extracted by mini-css-extract-plugin
export default {"form":"ChatForm_form__MxHb4","form__attach":"ChatForm_form__attach__zq4qL","form__textarea":"ChatForm_form__textarea__IiLFi","form__send":"ChatForm_form__send__nQ7gV"};